import { Link } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";

export default function PendingPage() {
  const { user, logout } = useAuth();
  return (
    <div
      data-testid="pending-page"
      className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6"
    >
      <div className="max-w-lg text-center">
        <span className="w-16 h-16 mx-auto rounded-full bg-[#0A192F] flex items-center justify-center">
          <Clock className="w-8 h-8 text-[#C5A059]" />
        </span>
        <h1 className="mt-6 font-heading text-3xl font-bold text-[#0A192F]">
          Approval pending
        </h1>
        <p className="mt-3 text-slate-600 leading-relaxed">
          Thanks for registering, <span className="font-semibold">{user?.name}</span>.
          A LexIntake admin is reviewing your credentials. You&apos;ll be able
          to subscribe and access matched cases as soon as you&apos;re
          approved.
        </p>
        <div className="mt-6 bg-white border border-slate-200 rounded-xl p-5 text-left">
          <p className="text-xs tracking-[0.18em] uppercase font-semibold text-slate-500 mb-2">
            What happens next
          </p>
          <ul className="space-y-2 text-sm text-slate-700">
            <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-[#C5A059] mt-0.5" /> Admin verifies your bar number and licensed states</li>
            <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-[#C5A059] mt-0.5" /> You receive approval (typically within 1-2 business days)</li>
            <li className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-[#C5A059] mt-0.5" /> Choose a subscription plan and start reviewing matched cases</li>
          </ul>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/">
            <Button data-testid="pending-home-btn" variant="outline" className="rounded-lg border-slate-300 text-[#0A192F]">
              Back to home
            </Button>
          </Link>
          <Button
            data-testid="pending-logout-btn"
            onClick={logout}
            className="bg-[#0A192F] hover:bg-[#112A46] text-white rounded-lg"
          >
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
}
